import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogConfirmationComponent } from '../../common/components/dialog-confirmation/dialog-confirmation.component';
import { MainComponent } from '../../common/pages/main/main.component';
import { GlobalConstants } from '../../../functions/src/shared/global-constants';
import { SelectService } from '../../common/services/select/select.service';
import { SettingService } from '../../common/services/setting/setting.service';
import { Action } from '../../services/action/action.model';
import { ActionService } from '../../services/action/action.service';
import { BackurlService } from 'src/common/services/backurl/backurl.service';
import { Tools } from 'src/common/services/tools';
import { GoinfreService } from 'src/common/services/goinfre/goinfre.service';
import { formatDate, formatDateRead, formatTel, formatTime } from 'functions/src/shared/tools';
import { ContactService } from 'src/services/contact/contact.service';


@Component({
  selector: 'visit-edit',
  templateUrl: './visit-edit.component.html',
  styleUrls: ['./visit-edit.component.scss']
})
export class VisitEditComponent extends MainComponent {

  public visitList: any[] = [];
  public GLOBAL = new GlobalConstants();
  public tools = new Tools();

  @Input()
  allMatchings: any[];

  @Input()
  action: any

  @Input()
  newAction: { check: boolean };

  @Output() doneFn: EventEmitter<any> = new EventEmitter<any>();
  @Output() addFn: EventEmitter<any> = new EventEmitter<any>();

  public printing = false;
  public file: any = null;

  constructor(
    protected _cd: ChangeDetectorRef,
    public setting: SettingService,
    public db: ActionService,
    public select: SelectService,
    protected route: ActivatedRoute,
    protected router: Router,
    public dialog: MatDialog,
    public backURL: BackurlService,
    private _goinfre: GoinfreService,
    private _contactService: ContactService,
  ) {
    super(_cd, setting, db, select, route, router, backURL, dialog);
    this.item = new Action(null, setting);
  }

  ngOnInit(): void {
    if (this.action && this.action.$key) {
      this._$key = this.action.$key;

      this.new = false;

      this.db.initItem(this);
      this._cd.markForCheck();

      this._bindItem().then(() => {
        this.pageConfig.loaded = true;
        this.refreshVisitList();
        if (this.newAction && this.newAction.check) { //Automatically goes to select matching if new action
          this.newAction.check = false;
          this.selectMatchings();
        }
      });

    }
  }

  _afterBindUpdates() {
    this.refreshVisitList();
    this.checkIfPrinted();
  }


  checkIfPrinted() {
    if (this.item.values.synaps?.filesActions) {
      for (const fileKey in this.item.values.synaps.filesActions) {
        this.file = Object.assign({ $key: fileKey }, this.item.values.synaps.filesActions[fileKey]);
      }
    }
  }

  refreshVisitList() {
    const visitTemp = [];
    if (this.item.values.synaps && this.item.values.synaps.visit && this.allMatchings) {
      for (const match of this.allMatchings) {
        if (this.item.values.synaps.visit[match.$key]) {
          visitTemp.push(match);
        }
      }
    }
    this.visitList = visitTemp;
  }

  validAction() {
    this.item.values.done = true;
    this.item.modify.done = true;
    this.item.values.doneDate = new Date();
    this.item.modify.doneDate = true;
    this.db.saveItem(this.item);
    this.doneFn.emit(this.item.values);
  }

  // dateAction() {
  //   const dialogRef = this.dialog.open(DatetimeDialogComponent, {
  //     width: '250px',
  //     disableClose: true,
  //     data: this.item.values.date,
  //   });

  //   dialogRef.afterClosed().subscribe(newDate => {
  //     if (newDate) {
  //       this.item.values.date = newDate;
  //       this.item.modify.date = true;
  //       this.saveItem();
  //     }
  //   });
  // }

  selectMatchings() {
    this.select.init(this.item, this.db, "visit", null, false);
    this.addFn.emit(this.item);
  }

  deleteItem() {
    const data = { title: 'Delete the Visit?', ok: false };
    const dialogRef = this.dialog.open(DialogConfirmationComponent, {
      width: '250px',
      disableClose: true,
      data: data
    });

    dialogRef.afterClosed().subscribe(() => {
      if (data.ok) {
        this.db.deleteItem(this.item);
      }
    });
  }

  async pdfVisit() {

    this.printing = true;

    const data: any = {
      vDate: formatDateRead(this.item.values.date),
      vTime: formatTime(this.item.values.date),
      v2Flag: false,
      en: true,
    }
    const items: { module: string, key: string }[] = [];
    let filename = formatDate(this.item.values.date);

    // GET CONTACTS

    items.push({ module: 'actions', key: this.item.values.$key });

    if (this.item.values.synaps && this.item.values.synaps.projectsActions) {
      for (const projectKey of Object.keys(this.item.values.synaps.projectsActions)) {
        const project = this.item.values.synaps.projectsActions[projectKey];
        data.salesFlag = project.type === 'sale';
        items.push({ module: 'projects', key: projectKey });
        filename += '-C' + project.ref;
        if (project.synaps && project.synaps.contactsProjects) {
          for (const contactKey of Object.keys(project.synaps.contactsProjects)) {

            const contact = await this._contactService.getData(contactKey);
            if (contact) {
              if (!data.v1ContactName) {
                data.v1ContactName = contact.fullname || null;
                data.v1ContactTel = contact.tels ? formatTel(Object.values(contact.tels).map((tel: any) => tel.number)[0] || null) : null;
                data.v1ContactEmail = contact.emails ? Object.values(contact.emails).map((email: any) => email.email)[0] || null : null;
                if (contact.lang !== 'en') {
                  data.en = false;
                }
              } else if (!data.v2ContactName) {
                data.v2Flag = true;
                data.v2ContactName = contact.fullname || null;
                data.v2ContactTel = contact.tels ? formatTel(Object.values(contact.tels).map((tel: any) => tel.number)[0] || null) : null;
                data.v2ContactEmail = contact.emails ? Object.values(contact.emails).map((email: any) => email.email)[0] || null : null;
              }
            }
          }
        }
      }
    }

    // GET PROPERTIES
    data.units = []
    for (const unit of this.visitList) {
      data.units.push({
        mandate: unit.mandate?.ref || null,
        address: unit.mandate?.city || null,
        price: unit.mandate?.priceDisplay || null,
      });
    }

    if (data.lang === 'fr') {
      filename += '-Bon-de-visite';
    } else {
      filename += '-Visit-Listing';
    }

    this._goinfre.createPDF('visitor_listing', filename, this.file, data, items, true).then(() => {
      this.printing = false;
    });

  }
}

